import Component from './Component'

export default class GraphicsComponent extends Component {
	render(p5, canvas) {
		return null
	}
}